import { expression } from "@skinsoft/selectors/manifestation-selectors";

export const STATS_KEYS = {
    alias: 'alias',
    archive: 'archive',
    auditCampaign: 'auditCampaign',
    auditRecord: 'auditRecord',
    authority: 'authority',
    conditionReport: 'conditionReport',
    entityField: 'entityField',
    expression: 'expression',
    item: 'item',
    location: 'location',
    manifestation: 'manifestation',
    specimen: 'specimen',
    thesaurus: 'thesaurus',
    thesaurusTerm: 'thesaurusTerm',
    work: 'work',
}